import React from "react"
import { Redirect } from "react-router-dom"

//Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Privacy from "../pages/Authentication/Privacy"
import DeleteAccount from "pages/DeleteAccount"
import Otp from "pages/Authentication/Otp"
import Setpwd from "pages/Authentication/Setpwd"
import UserProfile from "../pages/Authentication/user-profile"

//Dashboard
import Dashboard from "../pages/Dashboard/index"

//Employee List
import AddRoles from "pages/Staff/AddRoles"
import EditRoles from "pages/Staff/EditRoles"
import RolesPremissions from "pages/Staff/RolesPremissions"
import Departments from "pages/Staff/Departments"
import Staff from "pages/Staff/Staff"

//Listing
import Facilities from "pages/Services/Facilities"
import Category from "pages/Services/Category"
import AddListing from "pages/Services/AddListing"
import EditListing from "pages/Services/EditListing"
import Listing from "pages/Services/Listing"
import ViewListing from "pages/Services/ViewListing"
import SubCategory from "pages/Services/SubCategory"
import Templatecategory from "pages/Services/Templatecategory"
import Templates from "pages/Template/Templates"

//Vendors
import PendingVendorsList from "pages/Vendor/PendingVendorsList"
import Vendor from "pages/Vendor/Vendor"
import ViewVendor from "pages/Vendor/ViewVendor"
import PendingVendorListing from "pages/Vendor/PendingVendorListing"
import PendingBusinessManListing from "pages/Vendor/PendingBusinessManListing"
import VendorListing from "pages/Vendor/VendorListing"
import ViewVendorListing from "pages/Vendor/ViewVendorListing"
import VendorPlan from "pages/Plans/VendorPlan"
import UserPlans from "pages/Plans/UserPlans"
import UserPlanPayments from "pages/Plans/UserPlanPayments"
import ViewVendorSubsriptionList from "pages/Plans/ViewVendorSubsriptionList"
import RejectedVendors from "pages/Vendor/RejectedVendors"
import ViewVendorListingEdit from "pages/Vendor/ViewVendorListingEdit"

//Users
import Users from "pages/Users/Users"
import ViewUser from "pages/Users/ViewUser"
import UserWallet from "pages/Users/UserWallet"
import UserListing from "pages/Users/UserListing"
import PendingUserListing from "pages/Users/PendingUserListing"
import ViewUserListing from "pages/Users/ViewUserListing"
import UserPlan from "pages/Plans/UserPlan"
import ViewUserSubsriptionList from "pages/Plans/ViewUserSubsriptionList"
import BlockedUsers from "pages/Users/BlockedUsers"

//Banners
import Banner from "pages/Banner"
import VendorBanners from "pages/VendorBanners"

//Products 
import Productcat from "pages/Product/Productcat"
import Products from "pages/Product/Products"

//Notification
import Notification from "pages/Settings/Notification"

// whatsapp notifications
// import WhatsappTemplate from "pages/Whatsapp/WhatsappTemplate"
import WhatsappSend from "pages/Whatsapp/WhatsappSend"

//Settings
import Terms from "pages/Settings/Terms"
import PrivacyPolicy from "pages/Settings/PrivacyPolicy"
import Faqs from "pages/Settings/Faqs"
import Contact from "pages/Settings/Contact"
import UserCount from "pages/Settings/UserCount"

//Services
import AllServices from "pages/Recharges/AllServices"
import PendingServices from "pages/Recharges/PendingServices"
import CompletedServices from "pages/Recharges/CompletedServices"
import ViewService from "pages/Recharges/ViewService"

// adding new one
import Posters from "pages/Posters"


//Support
import PendingSupport from "pages/Support/PendingSupport"
import ResolvedSupport from "pages/Support/ResolvedSupport"
import UnsolvedSupport from "pages/Support/UnsolvedSupport"
import Community from "pages/Settings/Community"

import PlanPayments from "pages/Plans/PlanPayments"


import ViewPendingVendor from "pages/Vendor/ViewPendingVendor"

import InActiveVendors from "pages/Vendor/InActiveVendors"
import Agents from "pages/Agents/Agents"
import Agentview from "pages/Agents/Agentview"


const authProtectedRoutes = [
  //Dashboard
  { path: "/dashboard", component: Dashboard },
  { path: "/profile", component: UserProfile },

  { path: "/ViewPendingVendor", component: ViewPendingVendor },

  { path: "/PlanPayments", component: PlanPayments },
  { path: "/UserPlans", component: UserPlans },
  { path: "/UserPlanPayments", component: UserPlanPayments },

  { path: "/InActiveVendors", component: InActiveVendors },

  //EmployeeList
  { path: "/AddRoles", component: AddRoles },
  { path: "/EditRoles", component: EditRoles },
  { path: "/RolesPremissions", component: RolesPremissions },
  { path: "/Departments", component: Departments },
  { path: "/Staff", component: Staff },

    //Agents
  { path: "/agents", component: Agents },
  { path: "/agentview", component: Agentview },

  //Servicesa
  { path: "/AllServices", component: AllServices },
  { path: "/PendingServices", component: PendingServices },
  { path: "/CompletedServices", component: CompletedServices },
  { path: "/ViewService", component: ViewService },
  { path: "/Uploads", component: Posters },

  // i am adding the new component name is POSTERS
  { path: "/Uploads", component: Posters },


  //Listing
  { path: "/Facilities", component: Facilities },
  { path: "/Category", component: Category },
  { path: "/AddListing", component: AddListing },
  { path: "/EditListing", component: EditListing },
  { path: "/Listing", component: Listing },
  { path: "/ViewListing", component: ViewListing },
  { path: "/SubCategory", component: SubCategory },
  { path: "/Templatecategory", component: Templatecategory },
  { path: "/Templates", component: Templates },

  //Vendors
  { path: "/PendingVendorsList", component: PendingVendorsList },
  { path: "/RejectedVendors", component: RejectedVendors },
  { path: "/Vendor", component: Vendor },
  { path: "/ViewVendor", component: ViewVendor },
  { path: "/PendingVendorListing", component: PendingVendorListing },
  { path: "/PendingBusinessManListing", component: PendingBusinessManListing },     // adding new one
  { path: "/VendorListing", component: VendorListing },
  { path: "/ViewVendorListing", component: ViewVendorListing },
  { path: "/VendorPlan", component: VendorPlan },
  { path: "/ViewVendorSubsriptionList", component: ViewVendorSubsriptionList },
  { path: "/ViewVendorListingEdit", component: ViewVendorListingEdit },            // adding new one

  //Users
  { path: "/Users", component: Users },
  { path: "/ViewUser", component: ViewUser },
  { path: "/UserListing", component: UserListing },
  { path: "/PendingUserListing", component: PendingUserListing },
  { path: "/ViewUserListing", component: ViewUserListing },
  { path: "/UserWallet", component: UserWallet },
  { path: "/UserPlan", component: UserPlan },
  { path: "/ViewUserSubsriptionList", component: ViewUserSubsriptionList },
  { path: "/BlockedUsers", component: BlockedUsers },

  //Banners
  { path: "/Banner", component: Banner },
  { path: "/VendorBanners", component: VendorBanners },

  //Notification
  { path: "/Notification", component: Notification },

  // whatsapp notificatons
  // { path: "/whatsapp-template", component: WhatsappTemplate },
  { path: "/whatsapp-notifications", component: WhatsappSend },

  //Support
  { path: "/PendingSupport", component: PendingSupport },
  { path: "/ResolvedSupport", component: ResolvedSupport },
  { path: "/UnsolvedSupport", component: UnsolvedSupport },

  //Settings
  { path: "/Terms", component: Terms },
  { path: "/PrivacyPolicy", component: PrivacyPolicy },
  { path: "/Faqs", component: Faqs },
  { path: "/Contact", component: Contact },
  { path: "/UserCount", component: UserCount },
  { path: "/Community", component: Community },  // adding new one

  { path: "/product_cat", component: Productcat }, 
  { path: "/products", component: Products }, 

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/otp", component: Otp },
  { path: "/setpassword", component: Setpwd },
  { path: "/deleteaccount", component: DeleteAccount },
  { path: "/privacy", component: Privacy },
]

export { publicRoutes, authProtectedRoutes }
